import { GroupResponse, OrganisationResponse, PractitionerData } from 'api';
import { createGroupOrganisationHashMap } from './createGroupOrganisationMap';
import {
  isAdvancedUser,
  isGroupManager,
  isStandardUser,
  isSuperAdmin,
} from './role';

const isAbleToInvite = (
  {
    user: inviter,
    organisations: inviterOrganisations,
  }: { user?: PractitionerData; organisations: OrganisationResponse[] },
  {
    user: invitee,
    organisations: inviteeOrganisations,
  }: { user?: PractitionerData; organisations: OrganisationResponse[] },
  group?: GroupResponse,
  currentOrg?: OrganisationResponse,
): boolean => {
  if (!inviter) {
    return false;
  }
  if (
    isSuperAdmin(inviter.role) &&
    isSuperAdmin(invitee?.role) &&
    inviter.id !== invitee?.id &&
    (!currentOrg ||
      (currentOrg.visibility === 'PRIVATE' &&
        inviteeOrganisations.every(({ id }) => id !== currentOrg.id)))
  ) {
    // Super Admins can invite other Super Admins to private special handling organisations they do not have access to
    return true;
  }
  if (
    (isSuperAdmin(inviter.role) && isSuperAdmin(invitee?.role)) ||
    (isGroupManager(inviter.role) && isGroupManager(invitee?.role)) ||
    (isGroupManager(inviter.role) && isSuperAdmin(invitee?.role)) ||
    (isAdvancedUser(inviter.role) && isGroupManager(invitee?.role)) ||
    (isAdvancedUser(inviter.role) && isSuperAdmin(invitee?.role))
  ) {
    return false;
  }
  let inviteeSet = new Set(inviteeOrganisations.map(({ id }) => id));

  if (
    ((isGroupManager(inviter.role) && isAdvancedUser(invitee?.role)) ||
      (isAdvancedUser(inviter.role) && isAdvancedUser(invitee?.role)) ||
      (isGroupManager(inviter.role) && isStandardUser(invitee?.role)) ||
      (isAdvancedUser(inviter.role) && isStandardUser(invitee?.role))) &&
    group
  ) {
    const hashMap = createGroupOrganisationHashMap([group]);
    inviteeSet = new Set(
      inviteeOrganisations.map(({ id }) => id).filter((id) => !!hashMap[id]),
    );

    return !inviterOrganisations
      .filter(({ id }) => !!hashMap[id])
      .every(({ id }) => inviteeSet.has(id));
  }

  return !inviterOrganisations.every(({ id }) => inviteeSet.has(id));
};

export default isAbleToInvite;
